namespace Solovis.Reports.Parameters.Composites {

    export interface CompositeSelectionSetData {
        ownerEntityIds?: number[];
        entityIds?: number[];
        investmentIds?: number[];

        /**
         * componentSelectionSetRef matches data used for an asset selection set parameter control.
         */
        componentSelectionSetRef?: any;

        groupingDeclarations?: CompositeGroupingDeclarationData[];

        useOnlyMostRecentPropertyValue?: boolean;

        groupByCommonHoldings?: boolean;
        alwaysCreateCommonHoldingGroup?: boolean;

        removeEmptyComponents?: boolean;
        includeZeros?: boolean;
        createOtherGroups?: boolean;
        applyPerformanceOverlays?: boolean;

        lookThrough?: CompositeLookThroughData;

        twrSettings?: CompositeTwrSettings;

        allLabel?: string;
    }

    export interface CompositeGroupingDeclarationData {
        label?: string;
        declarationType?: "Unknown" | "Currency" | "ValueType" | "PropertyValue" | "Exposure" | "Owner";

        propertyDefinitionId?: number;
        resourceRef?: "InvestmentHoldingOrEntity" | "InvestmentHoldingOwnerOrEntity" | "Owner" | "TrueOwner";
        useOnlyMostRecentPropertyValue?: boolean;

        exposureProfileId?: number;
        exposureTagSetId?: number;

        groupByTrueOwner?: boolean;
        groupByOwnerLevel?: "Direct" | "True" | "Absolute";

        valueTypeTopLevelOnly?: boolean;

        levelSplitter?: string;

        tagRefGrouping?: TagRefGroupOptions;
    }

    export interface CompositeLookThroughData {
        lookThroughManagedFund?: boolean;
        lookThroughDrawdownFund?: boolean;
        maxLookThroughs?: null;
    }

    export interface CompositeTwrSettings {
        settingsSourceAssetResourceId?: boolean;
    }

    export interface TagRefGroupOptions {
        maxLevel?: number;
        expansionFilter?: any;
    };

}